import { Component, Input } from '@angular/core';
import { EventItem } from '../../interfaces/event';
import { singleBreakpoints } from '../../constants/single-carousel-breakpoints';

@Component({
  selector: 'app-events-carousel',
  templateUrl: './events-carousel.component.html',
  styleUrls: ['./events-carousel.component.scss']
})
export class EventsCarouselComponent {
  @Input() events!: EventItem[];

  breakpoints = singleBreakpoints;
}
